import { Workbox } from 'workbox-window';

if ('serviceWorker' in navigator) {
  const url = document.currentScript.getAttribute('data-service-worker-url');

  // Derive the correct scope from the current URL pathname.
  // e.g. /2/11/en/52/?... → /2/11/en/
  const parts = location.pathname.split('/').filter(Boolean);
  const correctScope = `/${parts.slice(0, 3).join('/')}/`;
  const correctScopeUrl = `${location.origin}${correctScope}`;

  // Remove any SW registered with a different (wrong) scope.
  // This fixes browsers that already have a rogue SW installed.
  (async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const reg of registrations) {
        if (reg.scope !== correctScopeUrl) {
          console.log('[SW] Removing rogue SW with scope:', reg.scope);
          await reg.unregister();
        }
      }
    } catch (err) {
      console.warn('[SW] Cleanup failed:', err);
    }
  })();

  const wb = new Workbox(url, { scope: correctScope });

  wb.addEventListener('controlling', (event) => {
    document.getElementById('splashscreen').style.display = 'flex';
    requestAnimationFrame(() => {
      window.location.reload(true);
    });
  });

  const register = wb.register();

  window._CACHE_URLS = async (urlsToCache) => {
    const registration = await register;
    if (registration.active) {
      registration.active.postMessage({
        type: 'CACHE_URLS',
        payload: { urlsToCache }
      });
    }
  };
}
